import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'

export const userEresources = () => {
  return (
    <>
      <RoutingMenu activeScreen="userEresources" />
      <div className=''>
        {/* <iframe
          src={`${config.RootUrl}/faculty/library/view/eResource/eResource.php?isIframe=true`}
          className="iframe col-md-12" >
        </iframe> */}

        {
          config.account == "faculty" ?
            <iframe
              src={`${config.RootUrl}/faculty/library/view/eResource/eResource.php?isIframe=true`}
              className="iframe col-md-12" >
            </iframe>
            :
            <iframe
              src={`${config.RootUrl}/student/library/view/eResource/eResource.php?isIframe=true`}
              className="iframe col-md-12" >
            </iframe>
        }
      </div>
    </>
  )
}
